import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PortalConfigContext } from '../../context';
import { ActionButtonModal } from '../Modals';
import { closeAuthModal } from '../../store/ui/actions';
import {
  GetAuthStateTitleMap,
  AUTH_STATES,
  GetContactText,
  GetMobileRestrictedDescription,
  GetSignUpText,
} from '../../constants/authConsts';
import history from '../../history';
import { REGISTER_PAGE } from '../../constants';
import useNavigate from '../../hooks/useNavigate';
import { RootState } from '../../store';
import BaseTypography from '../Text/BaseTypography';

const AuthModal = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state: RootState) => state.ui.authType);
  const closeModal = () => {
    dispatch(closeAuthModal());
  };

  React.useEffect(() => {
    if (authState === AUTH_STATES.SIGNED_IN) {
      window.location.href = '/';
    }
  }, [authState]);

  const portalConfig = React.useContext(PortalConfigContext);

  const { name, CompanyEmail } = portalConfig;

  const AuthStateTitleMap = GetAuthStateTitleMap(name);

  const modalProps = { open: false, onClose: closeModal };

  const { handleConfirm: confirmLeave } = useNavigate();

  if (authState) {
    modalProps.open = true;
  }

  const handleSignupClicked = () => {
    history.push(REGISTER_PAGE);
    closeModal();
  };

  const renderModal = () => {
    switch (authState) {
      case AUTH_STATES.CONTACT_US:
        return (
          <ActionButtonModal
            description="Contact Us Modal"
            title={AuthStateTitleMap[authState] || 'Contact Us'}
            mainComponent={GetContactText(name, CompanyEmail)}
            {...modalProps}
          />
        );
      case AUTH_STATES.DESKTOP_ONLY_MODAL:
        return (
          <ActionButtonModal
            title={AuthStateTitleMap[AUTH_STATES.DESKTOP_ONLY_MODAL]}
            mainComponent={
              <BaseTypography>
                {GetMobileRestrictedDescription(name)}
              </BaseTypography>
            }
            hideActions
            closeButton
            {...modalProps}
          />
        );
      case AUTH_STATES.CONFIRM_PAGE_CHANGE_MODAL:
        return (
          <ActionButtonModal
            title="Unsaved changes"
            mainComponent="If you leave this page, your changes will be lost."
            cancelActionText="Cancel"
            positiveActionText="Leave page"
            positiveAction
            onPositiveActionPerformed={confirmLeave}
            {...modalProps}
          />
        );
      case AUTH_STATES.SIGN_UP:
        return (
          <ActionButtonModal
            description="Sign up Modal"
            title={AuthStateTitleMap[authState] || 'Sign up'}
            mainComponent={GetSignUpText(name)}
            positiveAction
            positiveActionText="Signup"
            onPositiveActionPerformed={handleSignupClicked}
            {...modalProps}
          />
        );
      default:
        return null;
    }
  };

  return <div>{renderModal()}</div>;
};

export default AuthModal;
